import $ from 'jquery';
import activityTabs from '@/activities/layout/activityTabs';
import auditTabs from '@/audit/layout/auditTabs';
import cohortTabs from '@/cohorts/layout/cohortTabs';
import collectionTabs from '@/collections/layout/collectionTabs';
import datasetTabs from '@/datasets/layout/datasetTabs';
import homeTabs from '@/home/layout/homeTabs';
import requestTabs from '@/requests/layout/requestTabs';
import roleTabs from '@/roles/layout/roleTabs';
import searchTabs from '@/search/layout/searchTabs';
import themeTabs from '@/themes/layout/themeTabs';
import tokenTabs from '@/tokens/layout/tokenTabs';
import userTabs from '@/users/layout/userTabs';
import vocabularyTabs from '@/vocabularies/layout/vocabularyTabs';
import workspaceTabs from '@/workspaces/layout/workspaceTabs';
import notFoundTab from '@/home/layout/notFoundTab';
import { checkCurrentUser } from '@/users/helper';
import { tabState } from './state/state';

const tabs = [
  ...activityTabs,
  ...auditTabs,
  ...cohortTabs,
  ...collectionTabs,
  ...datasetTabs,
  ...homeTabs,
  ...requestTabs,
  ...roleTabs,
  ...searchTabs,
  ...themeTabs,
  ...tokenTabs,
  ...userTabs,
  ...vocabularyTabs,
  ...workspaceTabs,
];

export const findTabByUrl = (url) => (
  tabs.find(({ pathInfo }) => pathInfo.some((info) => info.test(url))) || notFoundTab
);

export const allowedTab = (tab, { permissions, currentUser, url }) => (
  tab.access(permissions, checkCurrentUser(currentUser, url)) ? tab : notFoundTab
);

export const compareTabs = (a, b) => {
  let result = 0;

  if (a.order < b.order) {
    result = -1;
  } else if (a.order > b.order) {
    result = 1;
  } else if (a.name < b.name) {
    result = -1;
  } else if (a.name > b.name) {
    result = 1;
  }

  return result;
};

const panelToTab = (component, selectedUrl) => {
  const { config } = component;
  const { url, tooltip } = config.componentState;
  const tab = findTabByUrl(url);

  return tabState(config.title, url, tooltip, selectedUrl === url, tab);
};

export const comparePanels = (a, b) => compareTabs(panelToTab(a), panelToTab(b));

export const tabsList = (panel, components) => {
  const selectedUrl = panel ? panel.config.componentState.url : '';
  return components.map((component) => panelToTab(component, selectedUrl));
};

const addIconToTab = ({ element, contentItem }) => {
  if ($(element).find('.tab_icon').length === 0) {
    const { url } = contentItem.config.componentState;
    const { icon } = findTabByUrl(url);
    element.prepend(`<i class="tab_icon ${icon} " />`);
  }
};

export const customiseHeader = (component, includeIcon) => {
  const { config } = component;
  const { tooltip } = config.componentState;
  const title = component.tab.element.find('.lm_title');

  if (tooltip) { title.prop('title', tooltip); } else { title.removeAttr('title'); }
  if (includeIcon) { addIconToTab(component.tab, config.component); }
};

export const onTabAddIcon = (container) => { container.on('tab', addIconToTab); };

export default tabs;
